import {mixpanelService} from '@/services/mixpanel/MixpanelService';
import {segmentService} from '@/services/segment/SegmentService';
import {ITrackingService} from '@/services/tracking/ITrackingService';
import {mockTrackingService} from '@/services/tracking/MockTrackingService';
import {TrackingProvider} from '@/services/tracking/TrackingProvider';
import {isLocalhost} from '@/utils/environment';

export const DEFAULT_TRACKING_PROVIDER = TrackingProvider.mixpanel;

// Params are injectable (default to the real provider/env check) purely so
// this selection logic can be unit tested against every branch without
// depending on the current value of DEFAULT_TRACKING_PROVIDER.
//
// Lives outside `useTrackingManager` (and outside React) so non-hook
// callers — e.g. `reAuth.ts`, which tracks WAF/auth events from the RTK
// Query layer — can resolve the same provider/localhost-mock logic instead
// of hardcoding a specific provider.
export const getTrackingService = (
  provider: TrackingProvider = DEFAULT_TRACKING_PROVIDER,
  localhost: boolean = isLocalhost,
): ITrackingService => {
  // Localhost always forces the mock, regardless of the requested provider.
  const resolvedProvider = localhost ? TrackingProvider.mock : provider;

  switch (resolvedProvider) {
    case TrackingProvider.segment:
      return segmentService();
    case TrackingProvider.mock:
      return mockTrackingService();
    case TrackingProvider.mixpanel:
    default:
      return mixpanelService();
  }
};
